import React from "react";
import PropTypes from "prop-types";

const propTypes = {
  t: PropTypes.func.isRequired,
  relatedPosts: PropTypes.array.isRequired,
  url: PropTypes.func.isRequired,
};

const RelatedQuestions = ({ t, relatedPosts = [], url }) => {
  return (
    <aside className="HelpSinglePost-relatedQuestions">
      <h1 className="HelpSinglePost-relatedQuestionsTitle">
        {t("spages.help.single.relatedQuestions")}
      </h1>
      <div className="HelpSinglePost-relatedQuestionsList">
        {relatedPosts.map((post) => {
          return (
            <article key={post.id} className="HelpSinglePost-relatedQuestion">
              <h1 className="HelpSinglePost-relatedQuestionTitle">
                <a
                  href={url("helpSinglePost", {
                    postId: post.id,
                  })}
                  className="link--primary"
                >
                  {post.title}
                </a>
              </h1>
            </article>
          );
        })}
      </div>
    </aside>
  );
};

RelatedQuestions.propTypes = propTypes;

export default RelatedQuestions;
